var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('AuthHeaderV2Component',{attrs:{"currentLayout":"customer-layout","currentUrl":_vm.currentUrl}}),_vm._t("default"),(_vm.displayFooter)?_c('AuthFooterV2Component'):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }